import React, { useState, useEffect } from "react";

/**
 * Hook that returns the dimensions of the ref element
 * @param {React.RefObject<HTMLElement>} ref - the reference to the element
 * @returns {Object} -object {width, height}
 */

const useRefDimensions = (ref) => {
    const [dimensions, setDimensions] = useState({ width: 1, height: 2 });

    const updateDimensions = () => {
        if (ref.current) {
            const { current } = ref;
            const boundingRect = current.getBoundingClientRect();
            const { width, height } = boundingRect;
            setDimensions({
                width: Math.round(width),
                height: Math.round(height),
            });
        }
    };

    useEffect(() => {
        ref && updateDimensions();
        window.addEventListener("resize", updateDimensions);

        return () => {
            window.removeEventListener("resize", updateDimensions);
        };
    }, [ref]);

    return dimensions;
};

export default useRefDimensions;
